export default __webpack_public_path__ + "media/zurb/img/services/process/advocate-img-ddce7a4ca21e2afd316ca45d487a5de5.png";